import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import ReactSVG from 'react-svg';
import { ToggleMenu } from "@ignitesales/neuro-application/src/neuro-ui";
import { startNewGuide, useNeuroState, useGuideConfig } from '@ignitesales/neuro-application';
import { FormattedMessage } from 'react-intl';
import RestartModal from './RestartModal';

let animationTimeout;

const resolveOnlineDomain = () => {
  const runmode = ignite.getRunMode();
  switch(runmode){
    case 'development':
        return `//solutions.${runmode}.moneymatch.com`
    case 'staging':
      return `//solutions.qa.moneymatch.com`
    case 'pilot':
      return `//solutions.training.moneymatch.com`
    case 'production':
      return `//solutions.fcbanking.com`
  }
}

const Header = ({ className, processingNavigation }) => {
  const { user } = useNeuroState();
  const { isBranchGuide } = useGuideConfig();
  const currentGuideUrl = user ? startNewGuide({ user }) : '#!';
  const newGuideUrl = user ? startNewGuide() : '#!';
  const [showMenu, setShowMenu] = useState(false);
  const [restartModalOpen, setRestartModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const cssBem = 'header';
  const classes = classnames(cssBem, className);
  const onlineSearchUrl = `${resolveOnlineDomain()}/guide/viewDetails`

  const toggleMenu = (
    <ToggleMenu
      animation="slideFromRight"
      className="header__menu"
      isOpen={showMenu}
      onOuterClick={() => setShowMenu(false)}
    >
      <a className="menu-item start-over" href={currentGuideUrl}>
        <i className="fa fa-step-backward" aria-hidden="true" />
        <FormattedMessage id="header.menu.start-over" tagName="span" />
      </a>
      <button
        className="menu-item new-guide"
        onClick={() => {
          setShowMenu(false);
          setRestartModalOpen(true);
        }}
      >
        <i className="fa fa-play" aria-hidden="true" />
        <FormattedMessage id="header.menu.new-guide" tagName="span" />
      </button>
      <a className="menu-item find" href={'/guide/viewDetails'}>
        <i className="fa fa-search" aria-hidden="true" />
        <FormattedMessage id="header.menu.find" tagName="span" />
      </a>
      <a className="menu-item find" href={onlineSearchUrl}>
        <i className="fa fa-globe" aria-hidden="true" />
        <FormattedMessage id="header.menu.find.online" tagName="span" />
      </a>
      <RestartModal
        cloneGuideUrl={currentGuideUrl}
        newGuideUrl={newGuideUrl}
        show={restartModalOpen}
        onClose={() => setRestartModalOpen(false)}
      />
    </ToggleMenu>
  );

  useEffect(() => {
    if (processingNavigation) {
      setIsLoading(true);
    } else {
      clearTimeout(animationTimeout);
      animationTimeout = setTimeout(() => setIsLoading(false), 1250);
    }
  }, [processingNavigation]);

  return (
    <>
      <header className={classes}>
        <div className={`${cssBem}__container--left`}>
          <div className={`${cssBem}__logo`}>
            <img src="/classpath/assets/images/logo.png" />
          </div>
        </div>
        <div className={`${cssBem}__container--right`}>
          {isLoading && (
            <div className={`${cssBem}__loading`}>
              <ReactSVG src="/classpath/assets/images/loading.svg" />
            </div>
          )}
          {!isLoading && isBranchGuide && (
            <div className={`${cssBem}__menu-btn`}>
              <button onClick={() => setShowMenu(!showMenu)}>
                <i className="fa fa-bars" />
              </button>
              {toggleMenu}
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
